import styled from '@emotion/styled';

export const Container = styled.div`
  position: relative;
  display: inline-block;
`;

export const ProfilesContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const CountBadge = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 32px;
  border: 1px solid var(--dk-bg, #fff);
  background-color: var(--dk-bg-subtle, #f5f5f5);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: -8px;

  color: var(--dk-text-strong, #5f636b);
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;

  &.hovered {
    border-color: #000;
  }
`;

// Mobile styles
export const MobileContainer = styled.div`
  position: relative;
  display: inline-block;
`;

export const MobileCountBadge = styled.div`
  position: absolute;
  top: 18px;
  left: 18px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid var(--dk-bg, #fff);
  background-color: var(--dk-bg-subtle, #f5f5f5);
  display: flex;
  align-items: center;
  justify-content: center;

  color: var(--dk-text-strong, #5f636b);
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;

  &.hovered {
    border-color: #000;
  }
`;
